import { Flex, Img, Text } from "@chakra-ui/react";

const ProductCard = ({ product, openDetails, store }) => {
  const {
    name = "",
    price = "",
    description = "",
    images = [],
    stock = 0,
  } = product;
  return (
    <Flex
      onClick={() => openDetails(product)}
      flex={1}
      p="25px"
      bg="white"
      h="auto"
      minH="300px"
      justifyContent="center"
      alignItems="center"
      flexDir={"column"}
      borderRadius="10px"
      boxShadow={"lg"}
      cursor="pointer"
      _hover={{
        boxShadow: "2xl",
      }}
    >
      <Flex w="100%" flex={2} overflow="hidden" minH="50%">
        <Img
          src={images[0]}
          alt={name}
          minH="100%"
          maxH="200px"
          w="100%"
          minW="100%"
          objectFit={"contain"}
        />
      </Flex>
      <Flex mt='20px' w='100%' justifyContent="center" flex={1} flexDir={"column"}>
        <Flex justifyContent='space-between' alignItems='center'>
            <Text fontSize="1.2em" fontWeight="500">
            {name}
            </Text>
            <Text fontSize="1em" fontWeight="200">
            ${price}
            </Text>
        </Flex>
        <Text fontSize=".8em" fontWeight="200">
          {description}
        </Text>
        <Text fontSize=".8em" fontWeight="200">
          {stock} {stock === 1 ? "disponible" : "disponibles"}
        </Text>
      </Flex>
    </Flex>
  );
};

export default ProductCard;
